import { makeStyles } from "@material-ui/core";
import { fromPairs } from "lodash";
import * as React from "react";

import { consts } from "../../common/consts";

const useStyles  = makeStyles((theme)=>({
  tooltipColorDot:{
    borderRadius: "50%",
    marginTop: 6,
    height: "7px",
    width: "7px",
    alignSelf:"center"
  },
  tooltipValue:{
    fontSize: 11, 
    color: "#14191C", 
    marginTop: 5,
    fontWeight:700,
    fontFamily:"Lato",
    alignSelf:"center"
  }
}))

const BarChartTooltip = (props: any) => {
  const classes = useStyles();
  return (
    <div style={{ height: "55px", width: "100px", backgroundColor: "#ffffff", position: "relative", borderBottom: 0 }}>
      <div style={{ textAlign: "center", height: "18px" }}>
        <h6 style={{ fontSize: 11, color: "#8B95A0", marginTop: "5px" }}>{props.data.Weekday}</h6>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-around",
          height: "7px",
          paddingBottom: 0,
          marginBottom: 0,
        }}
      >
        
        <div  style={{display: "flex", flexDirection:"column",}}> 
          <div className={classes.tooltipColorDot} style={{ backgroundColor: "#3b5e84" }}>.</div>
          <h6  className={classes.tooltipValue}>{props.data["6AM - 8AM"] ? props.data["6AM - 8AM"] : 0}</h6>
        </div>
        <div style={{display: "flex", flexDirection:"column",}}>
          <div className={classes.tooltipColorDot} style={{ backgroundColor: "#6DC8FF" }}>.</div>
          <h6 className={classes.tooltipValue}>{props.data["8AM - 10AM"] ? props.data["8AM - 10AM"] : 0}</h6>
        </div>
        <div style={{display: "flex", flexDirection:"column",}}>
          <div className={classes.tooltipColorDot} style={{ backgroundColor: "#4B753D" }}>.</div>
          <h6 className={classes.tooltipValue}>{props.data["10AM - 12PM"] ? props.data["10AM - 12PM"] : 0}</h6>
        </div>
        <div style={{display: "flex", flexDirection:"column",}}>
          <div className={classes.tooltipColorDot} style={{ backgroundColor: "#984DAB" }}>.</div>
          <h6 className={classes.tooltipValue}> {props.data["12PM - 2PM"] ? props.data["12PM - 2PM"] : 0}</h6>
        </div>
        <div style={{display: "flex", flexDirection:"column",}}>
          <div className={classes.tooltipColorDot} style={{ backgroundColor: "#3724C6" }}>.</div>
          <h6 className={classes.tooltipValue}>{props.data["2PM - 4PM"] ? props.data["2PM - 4PM"] : 0}</h6>
        </div>
        <div style={{display: "flex", flexDirection:"column",}}>
        <div className={classes.tooltipColorDot} style={{ backgroundColor: "#D89629" }}>.</div>
        <h6 className={classes.tooltipValue}>{props.data["Other"] ? props.data["Other"] : 0}</h6>
        </div>
        
      </div>

      <div style={{ position: "absolute", height: "23px", width: "25px", backgroundColor: "#ffffff", top: 40, left: 38, transform: `rotate(45deg)`, zIndex: -1 }}></div>
    </div>
  );
};

export default BarChartTooltip;
